import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { EndpointResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';

export const clearQuickBooksTokens = async (scope: RequestScope, options: WriteRequestOptions): Promise<EndpointResponse<unknown>> => {
  try {
    const response = await scopedApi(scope).get<EndpointResponse<unknown>>('quickbooks/clear_tokens', {
      ...options,
      semanticWrite: true,
    });
    return response.data;
  } catch (error) {
    return utils.error.handleAxiosError(error);
  }
};
